import axios from 'axios';

export default {
  data() {
    return {
      images: JSON.parse(localStorage.getItem('images')),
      filteredImages: JSON.parse(localStorage.getItem('filteredImages')),
    };
  },
  mounted() {
    const currentDate = Math.round(new Date().getTime());
    const date = localStorage.getItem('imagesDate');
    if (!date || date < currentDate) {
      const spreadsheetID = '1hKEuunXttw6a-UCxkgNDdK4p-Vr1ehLBUg31466Y-ZE';
      const url = `https://docs.google.com/spreadsheets/d/${spreadsheetID}/gviz/tq?tqx=out:json`;
      axios.get(url).then((response) => {
        const r = response.data.match(/google\.visualization\.Query\.setResponse\(([\s\S\w]+)\)/);
        if (r && r.length === 2) { 
          const table = JSON.parse(r[1]).table;
          const rows = table.rows;
          this.images = rows;
          this.filter(this.images);
          localStorage.setItem('images', JSON.stringify(this.images));
          localStorage.setItem('imagesDate', Math.round(new Date().getTime() + (24 * 3600)));
        }
      });
    }
  },
  methods: {
    handleForLoop(e) {
      const arr = [];
      for (let i = 0; i < e.c.length; i += 1) {
        if (e.c[i] && e.c[i].v) {
          arr.push(e.c[i].v);
        } else {
          return arr;
        }
      }
      return arr;
    },
    filter(elm) {
      const filter = {};
      elm.forEach((e) => {
        const arr = this.handleForLoop(e);
        const tag = arr[4].toLowerCase();
        const obj = {
          title: arr[0],
          description: arr[1],
          thumbnail: arr[2],
          url: arr[3],
        };
        if (filter[tag]) {
          filter[tag].push(obj);
        }
        if (!filter[tag]) {
          filter[tag] = [obj];
        }
      });
      this.filteredImages = filter;
      localStorage.setItem('filteredImages', JSON.stringify(filter));
    },
  },
};
